import Auth from '../api/auth';
import { clearCookiesOnLogout } from '../store/utils/api';

const AUTH_HEADER_KEYS = [
  'access-token',
  'token-type',
  'client',
  'expiry',
  'uid',
];

// ENGAGE: on any 401 from the dashboard API, always clear session + redirect
// to login. The previous behaviour gated on `Auth.hasAuthCookie()` which made
// the dashboard hang silently when the cookie had already been cleared but
// stale axios headers were still sending a dead session to the backend
// (the role-swap -> logout -> re-login footgun).
const parseErrorCode = error => {
  if (error?.response?.status === 401) {
    clearCookiesOnLogout();
  }

  return Promise.reject(error);
};

// ENGAGE: drop the auth headers from the axios instance defaults so an
// in-memory session cannot outlive its cookie. Called from logout flows.
export const clearAxiosAuthHeaders = axiosInstance => {
  if (!axiosInstance?.defaults?.headers?.common) return;
  AUTH_HEADER_KEYS.forEach(key => {
    delete axiosInstance.defaults.headers.common[key];
  });
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
